import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../service/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormHelper } from '../util/formHelper';
import { AliasRegistrationData } from '../model/AliasRegistrationData';


@Component({
  selector: 'app-link-alias-dialog',
  templateUrl: './link-alias-dialog.component.html',
  styleUrls: ['./link-alias-dialog.component.css']
})
export class LinkAliasDialogComponent implements OnInit {
  @ViewChild("linkAliasLoader", { static: true }) linkLoader;
  @ViewChild("createAliasLoader", { static: true }) createLoader;

  ownerUid: string;

  invalidEmail: boolean = false;
  aliasNotFoundError: boolean = false;

  newUserinvalidEmail: boolean = false;
  newUserInvalidPassword: boolean = false;
  newUserasswordsNotMatchError: boolean = false;
  userAlreadyExists: boolean = false;

  createAliasString = $localize`:@@link_alias_dialog_create_alias:Crea nuovo utente`;
  linkExistingOwnerString = $localize`:@@link_alias_dialog_link_existing_owner:Associa gestore esistente`;

  linkAliasForm = new FormGroup({
    email: new FormControl('')
  });

  newAliasForm = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(''),
    password2: new FormControl('')
  });

  constructor(public dialogRef: MatDialogRef<LinkAliasDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private userService: UserService,
    private snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef) {
    this.ownerUid = data.ownerUid;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {

  }

  linkAliasToOwner() {

    this.invalidEmail = false;
    this.aliasNotFoundError = false;

    let email = this.linkAliasForm.get('email').value;

    if (FormHelper.isValidEmail(email)) {
      this.linkLoader.showLoading();
      this.userService.linkAliasOwner(this.userService.meUser.uid, email).subscribe(data => {
        let snackBarRef = this.snackBar.open($localize`:@@link_alias_dialog_toast_link_success:Operatore associato con successo`, $localize`:@@link_alias_dialog_toast_close:Chiudi`, {
          duration: 3000,
          panelClass: ['green-snackbar']
        });
        setTimeout(() => {
          this.dialogRef.close("Success");
        }, 1000);
        this.linkLoader.hideLoading();
      }, err => {
        if (err.error.message == "user-not-found") {
          this.linkLoader.hideLoading();
          this.aliasNotFoundError = true;
        } else {
          this.linkLoader.showError();
        }
      });
    } else {
      this.invalidEmail = true;
      this.linkLoader.hideLoading();
    }
  }

  createAliasUser() {

    this.newUserinvalidEmail = false;
    this.newUserInvalidPassword = false;
    this.newUserasswordsNotMatchError = false;
    this.userAlreadyExists = false;

    let email = this.newAliasForm.get('email').value;
    let password = this.newAliasForm.get('password').value;
    let password2 = this.newAliasForm.get('password2').value;


    if (!email || email.length < 3) {
      this.newUserinvalidEmail = true;
      return false;
    }
    if (!this.isValidEmailAddress(email)) {
      this.newUserinvalidEmail = true;
      return false;
    }
    if (!password || password.length < 8) {
      this.newUserInvalidPassword = true;
      return false;
    }
    if (password != password2) {
      this.newUserasswordsNotMatchError = true;
      return false;
    }

    let aliasData = new AliasRegistrationData();
    aliasData.email = email;
    aliasData.password = password;

    this.createLoader.showLoading();
    this.userService.createAliasUser(this.userService.meUser.uid, aliasData).subscribe(data => {
      let snackBarRef = this.snackBar.open($localize`:@@link_alias_dialog_toast_create_success:Utente creato con successo`, $localize`:@@link_alias_dialog_toast_close:Chiudi`, {
        duration: 3000,
        panelClass: ['green-snackbar']
      });
      setTimeout(() => {
        this.dialogRef.close("Success");
      }, 1000);
      this.createLoader.hideLoading();
    }, err => {

      if (err.error.message == "user-already-exists") {
        this.createLoader.hideLoading();
        this.userAlreadyExists = true;
      } else {
        this.createLoader.showError();
      }
    });
  }

  isValidEmailAddress(emailAddress): boolean {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
